import api from '@services/api'

export const getAllDances = (
    page,
    pageSize,
    orderBy,
    search,
    filters,
    fromDate,
    toDate
) => {
    return (dispatch, getState) => {
        api.getAllDances(
            page,
            pageSize,
            orderBy,
            search,
            filters
            // fromDate,
            // toDate
        ).subscribe(
            (res) => {
                console.log('get all dances res', res)
                dispatch(setDances(res.data))
            },
            (error) => {
                console.log('get all dances error', error)
                Promise.resolve()
            }
        )
    }
}

// export const getDanceStylesOptions = () => {
//     return (dispatch) => {
//         api.getDanceStylesOptions().subscribe(
//             (res) => {
//                 console.log('getDancesStyles from api res', res)
//                 dispatch(setDanceStylesOptions(res.data.res))
//             },
//             (error) => console.log('getDancesTypes from api error', error)
//         )
//     }
// }

export const setDances = (dances) => ({
    type: 'SET_DANCES',
    dances,
})

//export const SET_DANCE_ON_EDIT = 'SET_DANCE_ON_EDIT'
export const setDanceOnAddProcess = (dance) => ({
    type: 'SET_DANCE_ON_ADD_PROCESS',
    dance,
})

export const setSaveFromReAkumSearch = (saveFromReAkumSearch) => ({
    type: 'SET_SAVE_FROM_RE_AKUM_SEARCH',
    saveFromReAkumSearch,
})

export const setDanceStylesOptions = (styles) => ({
    type: 'SET_DANCES_STYLES_OPTIONS',
    styles,
})
